/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { Left, NonEmptyList } from 'purify-ts';
import { BaseAutoTestStep } from './base';
import { mergeEithers } from './utils';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class RedactedAutotTestStep extends BaseAutoTestStep {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    parseInputData(data) {
        return data;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    getDataToSave() {
        return mergeEithers(this._baseGetDataToSave(), Left(NonEmptyList(['It is nota allowed to edit redacted tests.'])));
    }
}
